import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { PROFILE_URL } from 'src/constants/constants.js';
import { updateBodyClass } from 'src/helpers';
import Layout from 'src/ui/layout';
import { ProfileContainer } from './containers';
import intl from 'react-intl-universal';
import { newDashboardRoutes } from 'src/newDashboardRoutes';

class ProfileRoot extends React.Component {
  componentDidMount() {
    updateBodyClass('profile');
  }
  componentWillUnmount() {
    updateBodyClass('profile');
  }
  render() {
    return (
      <Layout headerName={intl.get('profile.pageTitle')}>
        <Switch>
          <Route
            path={PROFILE_URL}
            render={props => <ProfileContainer key={props.location.state ? props.location.state.relationshipContactId : null} {...props} />}
          />
        </Switch>
        {newDashboardRoutes}
      </Layout>
    );
  }
}

export default ProfileRoot;
